import { Typography } from 'antd';
import styled from 'styled-components';

const MainTitleStyled = styled(Typography.Title)<{ $align: 'center' | 'left' | 'right' }>`
	text-align: ${({ $align }) => $align};
`;

interface Props {
	children: string;
	className?: string;
	level?: 1 | 2 | 3 | 4;
	align?: 'center' | 'left' | 'right';
}

const MainTitle: React.FC<Props> = ({ children, level = 3, align = 'center', ...rest }) => (
	<MainTitleStyled level={level} $align={align} {...rest}>
		{children}
	</MainTitleStyled>
);

export default MainTitle;
